module.exports = __webpack_public_path__ + "static/media/record-left.dc5e709402f377f3ec628ff3c8449ead.png";